<app-anonymous-page-layout>
  <app-card>
    <app-page-title
      [title]="'PAGE.USER_INVITATION_LOGIN.TITLE' | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>
    <ng-container *ngIf="isValidLoginLink">
      <form class="form-layout" (submit)="signIn()" [formGroup]="form">
        <app-form-element
          class="item"
          [label]="'LABEL.EMAIL' | translate"
          inputId="email"
          [errors]="formHelper.getErrors('email')"
          [description]="'PAGE.USER_INVITATION_LOGIN.LABEL.EMAIL_DESCRIPTION' | translate"
        >
          <mat-form-field>
            <input matInput id="email" type="email" required [formControl]="form.controls.email" />
          </mat-form-field>
        </app-form-element>
        <app-form-element
          *ngIf="!isExistingUser"
          class="item"
          [label]="'LABEL.FIRSTNAME' | translate"
          inputId="firstname"
          [errors]="formHelper.getErrors('firstname')"
        >
          <mat-form-field>
            <input matInput id="firstname" required [formControl]="form.controls.firstname" />
          </mat-form-field>
        </app-form-element>
        <app-form-element
          *ngIf="!isExistingUser"
          class="item"
          [label]="'LABEL.LASTNAME' | translate"
          inputId="lastname"
          [errors]="formHelper.getErrors('lastname')"
        >
          <mat-form-field>
            <input matInput id="lastname" required [formControl]="form.controls.lastname" />
          </mat-form-field>
        </app-form-element>
        <div class="actions">
          <app-button [label]="'PAGE.USER_INVITATION_LOGIN.ACTION.LOGIN' | translate"></app-button>
        </div>
      </form>
    </ng-container>
    <ng-container *ngIf="!isValidLoginLink">{{ 'PAGE.USER_INVITATION_LOGIN.INVALID_LINK' | translate }}</ng-container>
  </app-card>
</app-anonymous-page-layout>
